angular.module('app', [
    'app.altair',
    'app.datatables',
    'app.routes',
    'app.templates',
    'app.controllers',
    'app.filters',
    'app.services',
    'app.factories',
    'app.providers',
    'app.directives',
    'app.config',
]);

angular.module('app.altair', ['selectize', 'icheck', 'textarea-autosize', 'ui.calendar', 'dragularModule', 'chart.js']);
angular.module('app.datatables', ['datatables', 'datatables.buttons', 'datatables.colreorder', 'datatables.columnfilter']);
angular.module('app.routes', ['ui.router', 'ui.router.state.events', 'ngStorage']);
angular.module('app.templates', []);
angular.module('app.controllers', ['ui.router', 'ngStorage', 'restangular', /*'ngAnimate',*/ 'pascalprecht.translate']);
angular.module('app.filters', []);
angular.module('app.services', ['ui.router', 'ngStorage', 'restangular']);
angular.module('app.factories', []);
angular.module('app.providers', []);
angular.module('app.directives', []);
angular.module('app.config', ['pascalprecht.translate']);
